/**
 * Persistência do JWT em localStorage. PAT NUNCA é persistido (mostrado apenas
 * uma vez na criação). Chaves usam prefixo do app para evitar colisão.
 */

export const KEY_TOKEN = 'acompanhamento:jwt';
const KEY_USER = 'acompanhamento:user';

export interface StoredUser {
  email: string;
  nomeCompleto: string;
  admin: boolean;
  /** Só no modo senha: se precisa trocar a senha no primeiro acesso. */
  forcePasswordChange?: boolean;
}

export function setAuth(token: string, user: StoredUser): void {
  localStorage.setItem(KEY_TOKEN, token);
  localStorage.setItem(KEY_USER, JSON.stringify(user));
}

export function getToken(): string | null {
  return localStorage.getItem(KEY_TOKEN);
}

export function getUser(): StoredUser | null {
  const raw = localStorage.getItem(KEY_USER);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredUser;
  } catch {
    return null;
  }
}

export function clearAuth(): void {
  localStorage.removeItem(KEY_TOKEN);
  localStorage.removeItem(KEY_USER);
}
